module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/202-taiwan-25fd419b8db58605e0ed82e068a52320.svg";